module.exports = __webpack_public_path__ + "img/bot-chip-setting-up-badge.590bf80d.svg";